import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=5b436af4&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=5b436af4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b436af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b436af4')) {
      api.createRecord('5b436af4', component.options)
    } else {
      api.reload('5b436af4', component.options)
    }
    module.hot.accept("./Tags.vue?vue&type=template&id=5b436af4&scoped=true", function () {
      api.rerender('5b436af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/Tags.vue"
export default component.exports